import axios from 'axios';
import {
  ALIMTALK_CSV_CONTENT_TYPE,
  ALIMTALK_CSV_UPLOAD_TIMEOUT_MS,
} from '../../../constants/service/app/alimtalkConstants';

/**
 * presigned URL로의 S3 직접 PUT 전용 클라이언트.
 *
 * SuperFetchV2를 쓰면 안 되는 이유(인터셉터):
 *  - req.headers = customHeader() 가 Content-Type 을 덮어쓰고 admin Bearer 토큰을 주입 → presigned 서명 불일치(403) + 토큰 유출
 *  - PUT 에 If-Match(etag) 주입 → S3에 무관/유해
 *  - 응답 인터셉터가 res.data 언랩(S3는 빈 바디+ETag) + 비2xx 시 전역 에러 모달
 * → 인터셉터/baseURL/auth 없는 순수 axios 인스턴스를 사용한다.
 */
const s3Client = axios.create();

/**
 * 실패(타임아웃 포함)는 그대로 전파한다 — 호출부(useUploadCsvMutation)의 onError가 토스트를 띄우고,
 * csvS3Key는 성공했을 때만 기록되므로 실패 시 직전 업로드 상태가 유지된다.
 */
export const putCsvToS3 = (uploadUrl: string, file: File, signal?: AbortSignal): Promise<void> =>
  s3Client
    .put(uploadUrl, file, {
      headers: { 'Content-Type': ALIMTALK_CSV_CONTENT_TYPE },
      // 미설정 시 axios 기본값 0(무제한) — 업로드가 멈추면 "업로드 중…" 상태로 폼이 잠긴 채 방치된다
      timeout: ALIMTALK_CSV_UPLOAD_TIMEOUT_MS,
      // 유형 전환/재업로드 시 진행 중 요청 취소 — 늦게 끝난 업로드가 csvS3Key를 되살리는 race 방지
      signal,
    })
    .then(() => undefined);
